<script>
const { VUE_APP_API_HOST } = process.env

export default {
  methods: {
    getTemplateFolders(type) {
      return this.$http.get(`${VUE_APP_API_HOST}/template-folders`, {
        params: { type },
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      })
      .then(
        (res) => res.body.folders || [],
        (err) => err
      )
    },

    newTemplateFolder(folder) {
      return this.$http
        .post(`${VUE_APP_API_HOST}/template-folders/`, folder, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        })
        .then(
          (res) => res,
          (err) => err
        )
    },

    updateTemplateFolder(folder) {
      return this.$http
        .put(`${VUE_APP_API_HOST}/template-folders/${folder.id}`, folder, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        })
        .then(
          (res) => res,
          (err) => err
        )
    },

    deleteTemplateFolder(id) {
      return this.$http
        .delete(`${VUE_APP_API_HOST}/template-folders/${id}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        })
        .then(
          (res) => res,
          (err) => err
        )
    },

    reorderTemplateFolders({ parentId, orderedIds }) {
      return this.$http
        .post(`${VUE_APP_API_HOST}/template-folders/position`, { parentId, orderedIds }, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        })
        .then(
          (res) => res,
          (err) => err
        )
    }
  }
}
</script>
